import React from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@components/kit/icons'
import './date-navigation.css'

interface DateNavigationProps {
  selectedDate: Date | null
  setSelectedDate: (date: Date) => void
}

function DateNavigation({
  selectedDate,
  setSelectedDate
}: DateNavigationProps) {
  const handlePrevDay = () => {
    if (!selectedDate) return
    const prevDay = new Date(selectedDate)
    prevDay.setDate(prevDay.getDate() - 1)
    setSelectedDate(prevDay)
  }

  const handleNextDay = () => {
    if (!selectedDate) return
    const nextDay = new Date(selectedDate)
    nextDay.setDate(nextDay.getDate() + 1)
    setSelectedDate(nextDay)
  }

  const formatDate = (date: Date): string => {
    if (!date) return 'No date selected'
    const month = date.toLocaleString('en-US', { month: 'short' })
    const day = date.getDate()
    const year = date.getFullYear()
    return `${month} ${day}, ${year}`
  }

  return (
    <div className='date-navigation'>
      <button
        className='date-navigation__button'
        onClick={handlePrevDay}
        aria-label='Previous day'
      >
        <ChevronLeftIcon width={6} height={12} fill='walrusNeutral700' />
      </button>

      <div className='date-navigation__date'>{formatDate(selectedDate)}</div>

      <button
        className='date-navigation__button'
        onClick={handleNextDay}
        aria-label='Next day'
      >
        <ChevronRightIcon width={6} height={12} fill='walrusNeutral700' />
      </button>
    </div>
  )
}

export default DateNavigation
